import { useEffect, useRef, useState } from "react";
import { FaUserDoctor } from "react-icons/fa6";
import { useAuthStore } from "../../../auth/hooks";
import { useForm } from "../../../hooks";
import { filterObject } from "../../../helpers";
import {
  ErrorMessage,
  Input,
  LoadingData,
  SuccessMessage,
  MainButton,
} from "../../ui";
import { useFormMessages, useFormEventStore } from "../../hooks";

const fieldKeys = [
  "firstName",
  "lastName",
  "phoneNumber",
  "country",
  "department",
  "city",
  "address",
];

const formValidations = {
  firstName: [
    (val) => (val ?? "").toString().trim().length > 0,
    "Los nombres no pueden ser vacios",
  ],
  lastName: [(value) => value.length > 0, "El apellido no puede ser vacio"],
  phoneNumber: [
    (value) => value.length > 9,
    "El numero de celular debe contener más de 9 digitos",
  ],
  country: [(value) => value.length > 0, "El país no puede ser vacio"],
  department: [
    (value) => value.length > 0,
    "El departamento no puede ser vacio",
  ],
  city: [(value) => value.length > 0, "La ciudad no puede ser vacia"],
  address: [(value) => value.length > 0, "La dirección no puede ser vacia"],
};

export const DoctorPersonalForm = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    user,

    // Methods
    startUpdateDoctor,
  } = useAuthStore();

  const { isLoading, message } = useFormEventStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const userRef = useRef(user);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    userRef.current,
    formValidations
  );

  const {
    setFormSubmitted,
    showErrorMessage,
    messageText,
    showSuccessMessage,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const handleSubmit = (e) => {
    e.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startUpdateDoctor(formState);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    userRef.current = filterObject(user, fieldKeys, "pick");
  }, [user]);

  // useEffect(() => {
  //   console.log("formState", formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log("formValidation", formValidation);
  // }, [formValidation]);

  return (
    <div className="d-flex flex-column flex-md-row gap-4">
      <div className="flex-shrink-1">
        <FaUserDoctor
          className="rounded-circle"
          style={{ width: "64px", height: "64px" }}
        />
      </div>

      <form className="row gy-3" onSubmit={handleSubmit}>
        <div className="col-12 col-md-6">
          <Input
            label="Nombres"
            value={formState.firstName}
            onInputChange={onInputChange}
            name="firstName"
            submit={validateForm}
            validation={formValidation.firstNameValid}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="Apellidos"
            value={formState.lastName}
            onInputChange={onInputChange}
            name="lastName"
            submit={validateForm}
            validation={formValidation.lastNameValid}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="Correo electrónico"
            value={user.email}
            onInputChange={() => {}}
            name="email"
            disabled={true}
            submit={validateForm}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="Número de celular"
            value={formState.phoneNumber}
            onInputChange={onInputChange}
            name="phoneNumber"
            submit={validateForm}
            validation={formValidation.phoneNumberValid}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="País"
            value={formState.country}
            onInputChange={onInputChange}
            name="country"
            submit={validateForm}
            validation={formValidation.countryValid}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="Departamento"
            value={formState.department}
            onInputChange={onInputChange}
            name="department"
            submit={validateForm}
            validation={formValidation.departmentValid}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="Ciudad"
            value={formState.city}
            onInputChange={onInputChange}
            name="city"
            submit={validateForm}
            validation={formValidation.cityValid}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="Dirección"
            value={formState.address}
            onInputChange={onInputChange}
            name="address"
            submit={validateForm}
            validation={formValidation.addressValid}
          />
        </div>
        <div className="col-12">
          <MainButton
            className="float-end"
            type={"submit"}
            disabled={isLoading}
          >
            Guardar
          </MainButton>
        </div>

        {/* Mensajes */}
        <>
          {isLoading && (
            <div className="col-12">
              <LoadingData />
            </div>
          )}
          {showErrorMessage && (
            <div className="col-12">
              <ErrorMessage>{messageText}</ErrorMessage>
            </div>
          )}
          {showSuccessMessage && (
            <div className="col-12">
              <SuccessMessage>{messageText}</SuccessMessage>
            </div>
          )}
        </>
      </form>
    </div>
  );
};
